export enum DelegationListItemStatus {
  UNDOWNLOADED = "UNDOWNLOADED",
  DOWNLOADED = "DOWNLOADED",
  DELETED = "DELETED",
}

export enum DelegationListItemType {
  MANUAL = "MANUAL",
  AUTO = "AUTO",
}

export type DelegationListItem = {
  uuid: string;
  cargoCompanyName: string;
  downloadedCsvAt?: Date | null;
  downloadedPdfAt?: Date | null;
  status: DelegationListItemStatus;
  delegationNumber: string;
  type: DelegationListItemType;
  workerName: string;
  dateFrom: Date;
  dateTo: Date;
  creationDate: Date;
  totalCost: number;
  totalDistance: number;
  humanId: number;
};

type DelegationList = {
  data: DelegationListItem[];
  totalCount: number;
};

export default DelegationList;
